export default __webpack_public_path__ + "static/media/Completed.8ed86c49.svg";